import styled from 'styled-components'

import { Text, StyledText } from '../../../components/text'

export default function Precautions() {
  return (
    <Container>
      <Text size={14} weight={600}>
        청약 유의 사항
      </Text>
      <SemiTitle size={12} color="text_secondary">
        청약 전 확인 사항
      </SemiTitle>
      <Text size={12} color="text_secondary">
        *청약 전, 통신사 본인 인증, 자택 주소 기입, NH농협 예치금 계좌 개설, 투자 적합성 테스트를 진행해야 신청이
        가능합니다.
      </Text>
      <Text size={12} color="text_secondary">
        *청약 기간 중 제한 없이 청약 취소 및 재청약이 가능합니다.
      </Text>
      <Text size={12} color="text_secondary">
        *청약이 마감된 이후에는 청약 철회가 불가능합니다.
      </Text>
      <Text size={12} color="text_secondary">
        *청약 마감 후 신청한 수량 내에서 균등 및 비례배정의 방식에 따라서 배정이 진행됩니다.
      </Text>
      <Text size={12} color="text_secondary">
        *청약 배정 결과는 아티피오 앱 내에서 투자자명부와 함께 배정공고일 이후 확인 가능합니다.
      </Text>
      <Text size={12} color="text_secondary">
        *청약관련 문의는 평일 영업시간(오전10시~오후 5시)동안 앱 내의 1:1문의를 통해 안내가 가능합니다.
      </Text>
      <Text size={12} color="text_secondary">
        *보다 자세한 청약관련 유의사항은 증권신고서와 투자설명서를 통해 확인해 주시기 바랍니다.
      </Text>
      <Text size={12} color="text_secondary">
        *청약 기간 중 청약 신청은 24시간 가능합니다. (※농협점검시간 23:45~00:20 제외)
      </Text>
      <Text size={12} color="text_secondary">
        *기초 자산(작품) 이미지를 무단으로 복제하거나 사용할 경우, 저작권 법에 의해 제재를 받을 수 있습니다.
      </Text>
      <SemiTitle size={12} color="text_secondary">
        청약 관련 유의 사항
      </SemiTitle>
      <Text size={12} color="text_secondary">
        1. 청약 철회는 청약 기간 내에만 가능하며, 청약 기간이 만료된 후에는 청약을 철회할 수 없습니다.
      </Text>
      <Text size={12} color="text_secondary">
        2. 청약의 철회를 다시 철회할 수 없으며, 이 경우 청약 기간 내에 새로운 청약을 하셔야 합니다.
      </Text>
      <Text size={12} color="text_secondary">
        3. 청약 기간 내 본 투자에 따라 유효한 청약을 완료한 투자자는 청약한 내용에 따라 증권을 배정받을 수 있습니다 단,
        청약 경쟁률, 청약 참여자 수 등에 따라 청약을 신청한 증권 수보다 적은 수의 증권을 배정받거나 경우에 따라서는
        투자자에게 1주도 배정되지 아니할 수 있습니다. 청약한도와 증권의 구체적인 배정 방법은 투자계약서 제17조 및 별지
        3을 참고하시기 바랍니다. 청약한 증권 전부를 배정받지 못할 경우 배정받은 주에 대한 금액을 제외한 청약증거금은
        투자자의 NH 농협 예치금 계좌로 환불 처리됩니다.
      </Text>
      <Text size={12} color="text_secondary">
        4. 회사를 제외한 어떠한 투자자도 발행 증권 총수의 50%를 초과하는 증권을 배정받거나 취득하지 못합니다.
      </Text>
      <Text size={12} color="text_secondary">
        5. 회사는 관련 법령에서 증권의 전자 등록 등 발행 방법이 마련되기 전까지 증권을 실물로 발행하지 않습니다.
      </Text>
      <Text size={12} color="text_secondary">
        6. 투자자는 증권을 타인에게 양도하거나 담보 제공 등의 처분 행위를 할 수 없습니다.
      </Text>
      <Text size={12} color="text_secondary">
        7. 투자계약에 의해 증권 소유자에게 부여되는 모든 권리는 증권에 일체화되어 있으며 이를 분리하여 처분하지
        못합니다.
      </Text>
      <Text size={12} color="text_secondary">
        8. 투자자는 취득한 증권 주수에 비례하는 비율로 다른 투자자와 기초자산을 공유하되, 기초자산에 대하여 최초의
        투자자명부 확정일로부터 3년간 또는 본 투자계약증권의 투자계약 제24조 제3항에 달리 정한 경우에는 그 기간 내에
        공유물의 분할을 청구하지 않을 것을 회사와 다른 투자자들에 대하여 확약(이하 ‘공유물 분할 금지 특약’이라고
        함)합니다.
      </Text>
      <Text size={12} color="text_secondary">
        9. 전항의 기간 만료일까지 투자계약에 의한 청산이 완료되지 않을 것으로 예상되는 경우, 회사는 그 만료일로부터
        역산하여 30일간 투자자에게 공시한 후, 공유물 분할 금지 특약을 2년간 또는 본 투자계약증권의 투자계약 제24조
        제4항에 달리 정한 경우에는 그 기간 동안 갱신할 수 있습니다. 투자자는 투자계약에 의해 회사와 다른 투자자에게
        대하여 공유물 분할 금지 특약의 갱신에 대해 동의함을 확약하고, 공유물 분할 금지 특약의 갱신에 대한 반대는 회사를
        제외한 투자자 전원의 동의가 있어야만 유효한 것으로 합니다.
      </Text>
      <Text size={12} color="text_secondary">
        10. 투자자는 회사 및 다른 투자자에 대하여 다른 투자자의 투자계약상의 권리를 해하는 행위를 하지 않아야 할 의무를
        부담합니다. 투자자는 투자계약에서 정한 방법에 의하지 않고는 다음의 행위를 할 수 없습니다.
      </Text>
      <Text size={12} color="text_secondary">
        (1) 기초자산의 인도 청구
      </Text>
      <Text size={12} color="text_secondary">
        (2) 기초자산의 사용 청구
      </Text>
      <Text size={12} color="text_secondary">
        (3) 기초자산에 관한 보존 행위
      </Text>
      <Text size={12} color="text_secondary">
        (4) 회사가 투자계약에 따라 진행하는 기초자산의 매각을 방해하는 행위
      </Text>
      <Text size={12} color="text_secondary">
        (5) 기타 회사나 다른 투자자들의 투자계약에 따른 권리나 이익을 침해하는 행위
      </Text>
      <Text size={12} color="text_secondary">
        11. 기초자산의 처분 손익은 투자계약에서 정하는 성과보수, 제세공과금, 비용 등을 공제한 후 산정됩니다.(1) 회사는
        투자자로부터 성과보수를 지급받을 수 있습니다.(2) 성과보수의 산정방법 및 지급방법은 투자계약서 별지
        6(성과보수)에서 정한 바에 따릅니다.(3) 회사는 증권 1주당 귀속되는 청산금(중간정산에 의한 청산금을 포함한다)이
        증권의 1주당 발행가액의 108%에 미달하는 경우 성과보수를 지급받지 않습니다.(4) 청산으로 인하여 투자자에게
        부과되는 제세공과금은 투자자가 부담합니다.(5) 회사는 투자자에게 부과되는 세금으로서 회사의 원천징수의무가 있는
        세금에 대해서는 처분 손익 분배금에서 원천징수합니다.(6) 회사는 투자자가 부담할 것으로 예상되는 제세공과금의
        일반적 산정기준 등을 투자자에게 안내할 수 있습니다.(7) 투자자는 위 (5) 및 (6)호에도 불구하고 제세공과금의 신고와
        납부에 대하여 최종적인 책임을 부담하며, 회사는 투자자가 제세공과금의 원천징수를 위하여 필요한 사항을 제공하지
        않거나 부정확하게 제공함으로 인하여 발생하는 결과에 대한 책임을 지지 않습니다.
      </Text>
      <Text size={12} color="text_secondary">
        12. 기초자산 매각을 위한 소요 기간은 작품별, 작품 수량 및 판매 채널에 따라 다를 수 있으며 최대 수익을 위해 매각
        소요 기간이 변경될 수 있습니다.
      </Text>
      <Text size={12} color="text_secondary">
        13. 기초자산의 의무적 매각 기한이 정해져 있지 아니하고 투자계약증권의 유통시장이 존재하지 아니하여 투자자는
        기초자산의 매각 완료 전에 투자금을 회수할 수 없고 자유로운 증권 거래를 통한 현금 환가가 어려울 수 있습니다.
      </Text>
      <Text size={12} color="text_secondary">
        14. 기초자산의 가치는 시장상황, 글로벌 경기, 거래량, 거래 추이에 따라 항상 시세의 변동이 있으므로, 기초자산의
        과거 거래내역이 미래의 기초자산의 가치를 보장하지 아니합니다.
      </Text>
      <Text size={12} color="text_secondary">
        15. 기초자산의 매각은 매각 진행 시 시세에 따라 진행되며, 투자금의 원금을 보장하지 않습니다.
      </Text>
      <Text size={12} color="text_secondary">
        16. 투자자는 투자 전 투자계약증권에 대한 투자설명서 및 투자계약서를 반드시 읽어보시기 바랍니다.
      </Text>
      <SemiTitle size={12} color="text_secondary">
        매각 등 포괄 위임 동의
      </SemiTitle>
      <Text size={12} color="text_secondary">
        1. 투자자는 기초자산의 공유지분권을 취득함과 동시에 회사에 기초자산의 보관, 관리, 보존 업무를 수행하기 위한
        일체의 권리 또는 권한을 위임하며, 이를 취소 또는 철회할 수 없습니다.
      </Text>
      <Text size={12} color="text_secondary">
        2. 투자자는 회사에 기초자산 매각대금을 증권 발행 총액의 100% 이상의 금액으로 할 것을 조건으로 기초자산의 처분에
        관한 권한을 회사에게 위임하며, 이를 취소 또는 철회할 수 없습니다. 다만, 투자자명부의 최초 확정 이후 3년 내에
        기초자산이 매각되지 아니한 경우에는 회사는 투자계약서에서 정한 바에 따라 증권 발행 총액의 100% 미만의 가액으로
        매각 가능합니다.
      </Text>
      <Text size={12} color="text_secondary">
        3. 회사는 기초자산의 취득을 포함하는 공동사업에 필요한 행위 및 부대되는 의사표시, 기초자산의 관리와 처분 및 그에
        부대되는 행위 등에 대한 권한을 투자계약서 별지 4(회사에게 위임되는 중요한 권리의무)가 정하는 바에 따라
        투자자로부터 위임 받는 것으로 간주합니다.
      </Text>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  li {
    list-style: none;
  }
`

const SemiTitle = styled(StyledText)`
  margin: 14px 0;
`
